import { FormControl as MuiFormControl, InputLabel, FormHelperText, Theme } from '@mui/material';
import { light } from '@mui/material/styles/createPalette';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { FormInputSize, getMuiSize } from '../helpers';

interface Props {
  name: string;
  label?: ReactNode;
  error?: string;
  className?: string;
  fullWidth?: boolean;
  children: ReactNode;
  size?: FormInputSize;
  light?: boolean;
}

const useStyles = createUseStyles<string, { light: boolean }>((theme: Theme) => ({
  helperText: {
    marginLeft: 0,
  },
  formControl: {
    '& label.MuiFormLabel-root.Mui-focused': {
      color: theme.palette.common.black,
      opacity: 0.8,
    },
    '& div.MuiInputBase-root': {
      '& fieldset': {
        borderColor: light ? theme.palette.gray : theme.palette.gray + ' !important',
      },
    },
  },
  inputLabel: light && {
    color: theme.palette.gray,
    opacity: 0.8,
  },
}));

const FormControl: FC<Props> = ({
  className = '',
  name,
  children,
  label = '',
  error = '',
  fullWidth = true,
  size = 'medium',
  light = false,
}) => {
  const styles = useStyles({ light });
  const hasError = !!error;
  const hasLabel = !!label;
  const labelId = `${name}-label`;
  const compClass = classNames(className, styles.formControl);
  const isSmall = ['small', 'x-small'].includes(size);
  const margin = isSmall ? 'dense' : 'normal';

  return (
    <MuiFormControl
      fullWidth={fullWidth}
      className={compClass}
      margin={margin}
      size={getMuiSize(size)}
    >
      {hasLabel && (
        <InputLabel id={labelId} className={styles.inputLabel}>
          {label}
        </InputLabel>
      )}
      {children}
      {hasError && (
        <FormHelperText className={styles.helperText} error>
          {error}
        </FormHelperText>
      )}
    </MuiFormControl>
  );
};

export default FormControl;
